import { campaignHandlers } from './campaign';
import { authHandlers } from './auth';

export const handlers = [...authHandlers, ...campaignHandlers];
